module.exports = __webpack_public_path__ + "static/media/Employee.892b7b0f.jpg";